import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tab component
 * @module
 * @param {element} children - Children element
 * @param {string} title - Title of tab component
 * @param {bool} hideStandardInactive - Not render inactive tab in standard view
 * @param {bool} disabled - Disabled
 */

const TabComponent = ({ children, isActiveTab }) => {
  return React.isValidElement(children) ? React.cloneElement(children, { isActiveTab }) : children;
}

TabComponent.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  hideStandardInactive: PropTypes.bool,
  disabled: PropTypes.bool
}

export default TabComponent;